import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import useWindowDimension from "../../../components/hooks/useWindowDimension";
import UserDetailsComponent from "./userDetailsComponent";

import { showToast } from "../../../store/features/toast/toastSlice";
import {
  currentBookingAction,
  deleteUserResponce,
  enableDisbledUserResponce,
  pastBookingAction,
} from "../../../store/features/user/userSlice";

// import "./userDetails.css";

const UserDetailsContainer = ({ props }) => {
  const { currentBookingResponse, pastBookingResponse } = useSelector(
    (state) => state?.users
  );
  /**
   * Initializes various variables and hooks for the component.
   * @returns None
   */
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pageSizeRef = useRef(4);
  const smarttableref = useRef();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const tableContainerRef = useRef(null);
  const dimensions = useWindowDimension();

  const buttonDisable = useRef(false);
  const user = state?.itemData || null;

  const [userId, setUserId] = useState("");
  const [showDeleteUserModal, setshowDeleteUserModal] = useState(false);
  const closeDeleteUserModal = () => setshowDeleteUserModal(false);
  const [showStatusModal, setShowStatusModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [placeHolder, setPlaceHolder] = useState(true);
  const [searchValue, setSearchValue] = useState(null);
  const [showViewTicketModal, setShowViewTicketModal] = useState(false);

  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [userContentHeight, setUserContentHeight] = useState("");
  const [tabHeight, setTabHeight] = useState("");
  const [isCheckSwitch, setIsCheckSwitch] = useState(true);

  /**
   * Executes a side effect after the component has rendered.
   * The side effect sets the `placeHolder` state to `false` after a delay of 2000 milliseconds.
   * @returns None
   */
  useEffect(() => {
    setTimeout(() => {
      setPlaceHolder(false);
    }, 2000);
  });
  const [deleteUser, setDeleteUser] = useState();
  const onDeleteUser = async () => {
    dispatch(deleteUserResponce(deleteUser?._id)).then((resultAction) => {
      if (deleteUserResponce.fulfilled.match(resultAction)) {
        dispatch(
          showToast({
            show: false,
            message: resultAction?.payload?.message,
            type: "success",
          })
        );
        closeDeleteUserModal();
        navigate("/users-management");
      } else if (deleteUserResponce.rejected.match(resultAction)) {
        closeDeleteUserModal();

        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };
  useEffect(() => {
    dispatch(pastBookingAction(user?._id));

    dispatch(currentBookingAction(user?._id));
  }, [dispatch, user?._id]);

  /**
   * Opens the delete user modal for the specified item.
   * @param {{Event}} e - The event object.
   * @param {{any}} item - The item to be deleted.
   * @returns None
   */
  const openDeleteUserModal = (e, item) => {
    setshowDeleteUserModal(true);
  };

  /**
   * Loads more items when triggered, with a delay of 2000 milliseconds.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 10;
    }, 2000);
  };

  /**
   * Debounces the handleTableScroll function to prevent it from being called too frequently.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * and if there are more items to load. If both conditions are met, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer.scrollTop + tableContainer.clientHeight >=
        tableContainer.scrollHeight;
      if (isAtBottom && currentBookingResponse.length > pageSizeRef.current) {
        loadMoreItems();
      }
      if (isAtBottom && pastBookingResponse.length > pageSizeRef.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is removed when the component is unmounted.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  const [screenWidth, setScreenWidth] = useState(window.screen.width);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.screen.width]);

  /**
   * Updates the heights of various elements on the page when the loading state changes.
   * @param {{boolean}} loading - The loading state of the page.
   * @returns None
   */

  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("table-responsive")[0].offsetHeight
      );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
    setTabHeaderHeight(document.getElementsByTagName("thead")[0].offsetHeight);
    setUserContentHeight(
      document.getElementsByClassName("userContaint")[0].offsetHeight
    );
    setTabHeight(
      document.getElementsByClassName("user-details-tabs")[0].offsetHeight
    );
  }, [loading]);

  /**
   * An array of column objects used for displaying a table.
   * Each column object contains a label, key, filter function, and sorting flag.
   * @type {Array}
   */
  const pastColumns = [
    {
      label: (
        <>
          {t("EVENT_DETAILS")}{" "}
          <span className="thCount">{pastBookingResponse.length}</span>
        </>
      ),
      key: "title",
      filter: false,
      sorting: false,
    },

    {
      label: <>{t("ARTIST")}</>,
      key: "artist",
      filter: false,
      sorter: false,
    },
    {
      label: <>{t("EVENT_TIMINGS")}</>,
      key: "eventTimings",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("EVENT_STATUS")}</>,
      key: "eventstatus",
      filter: false,
      sorting: false,
    },
    {
      label: <>{screenWidth > 1440 ? t("TICKET_ID") : t("TICKET_DETAILS")}</>,
      key: "ticketId",
      filter: false,
      sorting: false,
    },

    {
      label: (
        <>
          {dimensions.width < 1631 ? t("BOOKING_TIMING") : t("BOOKING_TIMING")}
        </>
      ),
      key: "bookingtiming",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("HOME_DELIVERY")}</>,
      key: "ticketSold",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("TICKET_PRICE")}</>,
      filter: false,
      key: "ticketPrice",
      sorting: false,
    },
    {
      label: <></>,
      key: "viewTicker",
      filter: false,
      sorting: false,
    },
  ];
  const currentColumns = [
    {
      label: (
        <>
          {t("EVENT_DETAILS")}{" "}
          <span className="thCount">{currentBookingResponse.length}</span>
        </>
      ),
      key: "title",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("EVENT_TIMINGS")}</>,
      key: "eventTimings",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("ARTIST")}</>,
      key: "artist",
      filter: false,
      sorter: false,
    },

    {
      label: <>{t("EVENT_STATUS")}</>,
      key: "eventstatus",
      filter: false,
      sorting: false,
    },
    {
      label: <>{screenWidth > 1440 ? t("TICKET_ID") : t("TICKET_DETAILS")}</>,

      key: "ticketId",
      filter: false,
      sorting: false,
    },

    {
      label: (
        <>
          {dimensions.width < 1631 ? t("BOOKING_TIMING") : t("BOOKING_TIMING")}
        </>
      ),
      key: "bookingtiming",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("HOME_DELIVERY")}</>,
      key: "ticketSold",
      filter: false,
      sorting: false,
    },
    {
      label: <>{t("TICKET_PRICE")}</>,
      filter: false,
      key: "ticketPrice",
      sorting: false,
    },
    {
      label: <></>,
      key: "viewTicker",
      filter: false,
      sorting: false,
    },
  ];

  const pageTitle = [
    {
      title: "Users",
      path: "/users-management",
    },
    {
      title: "Users",
      path: "/users-management",
    },
  ];

  const openExportModal = () => {
    setTimeout(() => {
      dispatch(
        showToast({
          message: t("USER_HAS_BEEN_EXPORTED_SUCCESSFULLY"),
          type: "success",
        })
      );
      navigate("/users-management");
    }, 1500);
  };

  /**
   * Displays a toast notification indicating that a download was successful.
   * @returns None
   */
  const downloadUserValue = () => {
    dispatch(
      showToast({
        message: t("DOWNLOADED_SUCCESSFULLY"),
        type: "success",
      })
    );
  };

  const onCheckAction = async (e, item) => {
    if (isCheckSwitch) {
      setShowStatusModal(true);
      setUserId(item?._id);
    } else {
      unableAction(e, item._id);
    }
  };

  /**
   * Function to handle the proceed action after a certain event.
   * It sets the value of isCheckSwitch to false and showStatusModal to false.
   * It then dispatches a showToast action with a success message.
   * Finally, it closes the deleteUserModal after a delay of 1000 milliseconds.
   * @returns None
   */

  const unableAction = async (e, id) => {
    const params = {
      status: "active",
      _id: id,
    };
    dispatch(enableDisbledUserResponce(params)).then((resultAction) => {
      if (enableDisbledUserResponce.fulfilled.match(resultAction)) {
        setIsCheckSwitch(true);
        setTimeout(() => {
          dispatch(
            showToast({
              show: false,
              message: resultAction?.payload?.res?.message,
              type: "success",
            })
          );
          closeDeleteUserModal();
        }, 1000);
      } else if (enableDisbledUserResponce.rejected.match(resultAction)) {
        closeDeleteUserModal();

        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };
  const onProcced = async () => {
    const params = {
      status: "deactive",
      _id: userId,
    };
    dispatch(enableDisbledUserResponce(params)).then((resultAction) => {
      if (enableDisbledUserResponce.fulfilled.match(resultAction)) {
        setIsCheckSwitch(false);
        setShowStatusModal(false);
        setTimeout(() => {
          dispatch(
            showToast({
              show: false,
              message: resultAction?.payload?.res?.message,
              type: "success",
            })
          );
          closeDeleteUserModal();
        }, 1000);

        buttonDisable.current = false;
      } else if (enableDisbledUserResponce.rejected.match(resultAction)) {
        closeDeleteUserModal();

        dispatch(
          showToast({
            show: false,
            message: resultAction?.error?.message,
            type: "error",
          })
        );
      }
    });
  };

  /**
   * Clears the search input field by programmatically clicking the first button element
   * within the smart table component.
   * @returns None
   */
  const clearSearchButton = () => {
    smarttableref.current.querySelectorAll("button")[0].click();
  };

  const onTableFilterChange = (filterText) => {
    setSearchValue(filterText);
  };
  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };

  const editUserFun = () => {
    navigate("/users-management", {
      state: {
        state,
      },
    });
  };

  const closeDeactivateModal = () => setShowStatusModal(false);

  const closeViewTicketModal = () => setShowViewTicketModal(false);
  const openviewTicketModal = (e, item) => {
    setShowViewTicketModal(true);
  };

  const backPageFunction = () => {
    navigate("/users-management");
  };

  return (
    <UserDetailsComponent
      pastBookings={pastBookingResponse}
      currentBooking={currentBookingResponse}
      user={user}
      backPageFunction={backPageFunction}
      pastColumns={pastColumns}
      currentColumns={currentColumns}
      pageTitle={pageTitle}
      dimensions={dimensions}
      tabHeight={tabHeight}
      userContentHeight={userContentHeight}
      tabHeaderHeight={tabHeaderHeight}
      breadcrumbHeight={breadcrumbHeight}
      loaderHtml={loaderHtml}
      loading={loading}
      tableContainerRef={tableContainerRef}
      noDataFound={"noDataFound"}
      noDataTitle={t("NO_REPORT_FOUND")}
      noDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_REPORTS_PLEASE_TRY_SEARCHING_AGAIN"
      )}
      openExportModal={openExportModal}
      showDeleteUserModal={showDeleteUserModal}
      openDeleteUserModal={(e, item) => {
        setDeleteUser(item);
        openDeleteUserModal(e, item);
      }}
      closeDeleteUserModal={closeDeleteUserModal}
      onDeleteUser={onDeleteUser}
      state={state}
      downloadUserValue={downloadUserValue}
      onCheckAction={(e, user) => onCheckAction(e, user)}
      showStatusModal={showStatusModal}
      onProcced={onProcced}
      clearSearchButton={clearSearchButton}
      editUserFun={() => {
        editUserFun();
      }}
      closeDeactiveModal={closeDeactivateModal}
      onTableFilterChange={onTableFilterChange}
      searchValue={searchValue}
      searchFilterClear={searchFilterClear}
      placeHolderShimer={placeHolder}
      openviewTicketModal={openviewTicketModal}
      closeViewTicketModal={closeViewTicketModal}
      showViewTicketModal={showViewTicketModal}
      isCheckSwitch={isCheckSwitch}
    />
  );
};
export default UserDetailsContainer;
